<template>
  <div class="col-md-3 mb-sm-3 mb-md-0">
    <b-list-group role="tablist" class="shadow bg-white h-100 p-b rounded-0">
      <b-list-group-item
        @click="
          page = 'atendimento';
          $emit('page', page);
          redirectAtendimentos();
        "
        :class="page == 'atendimento' ? 'active' : ''"
        class="nav-link"
        href="#"
        role="tab"
      >
        Atendimento
      </b-list-group-item>
      <b-list-group-item
        @click="
          page = 'atividade';
          $emit('page', page);
          redirectAtividades();
        "
        :class="page == 'atividade' ? 'active' : ''"
        class="nav-link"
        href="#"
        role="tab"
      >
        Atividade
      </b-list-group-item>

      <b-list-group-item
        @click="
          page = 'acolhimentos';
          $emit('page', page);
          redirectAcolhimento();
        "
        :class="page == 'acolhimentos' ? 'active' : ''"
        class="nav-link"
        href="#"
        role="tab"
        v-if="$store.state.user.role_details.name != 'Nível Básico'"
      >
        Acolhimento
      </b-list-group-item>
      <b-list-group-item
        @click="
          page = 'acompanhamento';
          $emit('page', page);
          redirectAcompanhamento();
        "
        :class="page == 'acompanhamento' ? 'active' : ''"
        class="nav-link"
        href="#"
        role="tab"
        v-if="$store.state.user.role_details.name != 'Nível Básico'"
      >
        Acompanhamento
      </b-list-group-item>
      <b-list-group-item
        @click="
          page = 'beneficios';
          $emit('page', page);
          redirectBeneficios();
        "
        :class="page == 'beneficios' ? 'active' : ''"
        class="nav-link"
        href="#"
        role="tab"
        v-if="$store.state.user.role_details.name != 'Nível Básico'"
      >
        Benefício
      </b-list-group-item>
      <b-list-group-item
        @click="
          page = 'encaminhamento';
          $emit('page', page);
          redirectEncaminhamentos();
        "
        :class="page == 'encaminhamento' ? 'active' : ''"
        class="nav-link"
        href="#"
        role="tab"
        v-if="$store.state.user.role_details.name != 'Nível Básico'"
      >
        Encaminhamento
      </b-list-group-item>
      <b-list-group-item
        @click="
          page = 'referencia';
          $emit('page', page);
          redirectReferencias();
        "
        :class="page == 'referencia' ? 'active' : ''"
        class="nav-link"
        href="#"
        role="tab"
        v-if="$store.state.user.role_details.name != 'Nível Básico'"
      >
        Referência e Contrarreferência
      </b-list-group-item>
      <b-list-group-item
        @click="
          page = 'medidas';
          $emit('page', page);
          redirectMSE();
        "
        :class="page == 'medidas' ? 'active' : ''"
        class="nav-link"
        href="#"
        role="tab"
        v-if="$store.state.user.role_details.name != 'Nível Básico'"
      >
        Medida Socioeducativa
      </b-list-group-item>
      <b-list-group-item
        @click="
          page = 'violacaodedireito';
          $emit('page', page);
          redirectViolacaodedireitos();
        "
        :class="page == 'violacaodedireito' ? 'active' : ''"
        class="nav-link"
        href="#"
        role="tab"
        v-if="$store.state.user.role_details.name != 'Nível Básico'"
      >
        Violação de Direitos
      </b-list-group-item>
      <b-list-group-item
        @click="
          page = 'programassociais';
          $emit('page', page);
          redirectProgramasSociais();
        "
        :class="page == 'programassociais' ? 'active' : ''"
        class="nav-link"
        href="#"
        role="tab"
        v-if="$store.state.user.role_details.name != 'Nível Básico'"
      >
        Programa Social
      </b-list-group-item>
    </b-list-group>
  </div>
</template>
<script>
export default {
  props: ["active", "pageActive", "familia"],
  data() {
    return { page: "atendimento" };
  },
  watch: {
    active() {
      //console.log(this.active);
      if (this.active) {
        this.page = this.active;
      }
    },
  },
  mounted() {
    if (this.active) {
      this.page = this.active;
    }
  },
  methods: {
    redirectProntuario() {
      this.$router.push(
        `/dashboard/familias/edit/${this.$route.query.familia_id}`
      );
    },
    redirectAtendimentos() {
      // this.active = "atendimento";
      // if (this.active != "atendimento" && this.active != undefined) {
      this.$router.push({
        path: `/dashboard/atendimentos/${this.$route.query.familia_id}`,
        query: { familia_id: this.$route.query.familia_id },
      });
      //}
    },   
				redirectAtividades() {
      // this.active = "atendimento";
      // if (this.active != "atendimento" && this.active != undefined) {
      this.$router.push({
        path: `/dashboard/familia/atividades/${this.$route.query.familia_id}`,
        query: { familia_id: this.$route.query.familia_id },
      });
      //}
    },
    redirectEncaminhamentos() {
      this.$router.push({
        path: `/dashboard/encaminhamentos/${this.$route.query.familia_id}`,
        query: { familia_id: this.$route.query.familia_id },
      });
    },
    redirectBeneficios() {
      this.$router.push({
        path: `/dashboard/familia/beneficios/${this.$route.query.familia_id}`,
        query: { familia_id: this.$route.query.familia_id },
      });
    },
    redirectProgramasSociais() {
      var familia_id = this.$route.query.familia_id
        ? this.$route.query.familia_id
        : this.familia;
      this.$router.push({
        path: `/dashboard/programassociais/beneficiarios/${familia_id}`,
        query: { familia_id: familia_id },
      });
    },
    redirectMSE() {
      this.$router.push({
        path: `/dashboard/medidas/${this.$route.query.familia_id}`,
        query: { familia_id: this.$route.query.familia_id },
      });
    },
    redirectAcompanhamento() {
      this.$router.push({
        path: `/dashboard/acompanhamentos/${this.$route.query.familia_id}`,
        query: { familia_id: this.$route.query.familia_id },
      });
    },
    redirectViolacaodedireitos() {
      this.$router.push({
        path: `/dashboard/violacaodedireitos/${this.$route.query.familia_id}`,
        query: { familia_id: this.$route.query.familia_id },
      });
    },
    redirectReferencias() {
      this.$router.push({
        path: `/dashboard/referenciamentos/${this.$route.query.familia_id}`,
        query: { familia_id: this.$route.query.familia_id },
      });
    },
    redirectAcolhimento() {
      this.$router.push({
        path: `/dashboard/familia/acolhimentos/${this.$route.query.familia_id}`,
        query: { familia_id: this.$route.query.familia_id },
      });
    },
  },
};
</script>
